// Core Imports
import GraniteError from 'granite-admin/utils/granite-error';
import GraniteAPIClient from 'granite-admin/utils/granite-client';

// Application Imports
import SidemenuEntity from 'granite-admin/accounts/entities/sidemenu';
import { env } from 'granite-admin/env';

/**
 *  GetSidemenuItems api call implementation.
 *
 * @returns {object} containing a array: result, count
 * @throws {GraniteError} if xhr request fails
 */

const url = env.REACT_APP_ORGANISATION_BASE_URL || process.env.REACT_APP_ORGANISATION_BASE_URL;
async function getPermissionsAndSideMenuItems() {
  try {
    const response = await GraniteAPIClient(url).get('/side-menus/?page_size=100');
    response.data.results.sort((firstItem, secondItem) => {
      return firstItem.sequence - secondItem.sequence;
    });
    const sidemenuItems = response.data.results.map(item => new SidemenuEntity(item));
    // const permissions = response.data.permissions

    return sidemenuItems;
  } catch (error) {
    // const errorMessage = error.message
    throw new GraniteError(error.data && error.data.title);
  }
}
export { getPermissionsAndSideMenuItems };